import Cookies from 'js-cookie'
import { handleSessionExpired } from '@/lib/authToken'
import type { CalendarEvent } from '../types/index.js'

// Connect/disconnect for Google Calendar go through the combined
// features/google-workspace flow now (one consent for Gmail + Calendar) —
// this service only reads events for the calendar view.
const API_BASE = (import.meta.env?.VITE_API_URL as string) || ''

function buildUrl(path: string): string {
  if (API_BASE) return `${API_BASE.replace(/\/+$/, '')}/${path.replace(/^\/+/, '')}`
  return path.startsWith('/') ? path : `/${path}`
}

function authHeaders(): Record<string, string> {
  const token = Cookies.get('token')
  return token ? { Authorization: `Bearer ${token}` } : {}
}

export async function getCalendarEvents(workspaceId: string, from: string, to: string): Promise<CalendarEvent[]> {
  const token = Cookies.get('token')
  const params = new URLSearchParams({ from, to })
  const res = await fetch(buildUrl(`/api/workspaces/${workspaceId}/calendar/events?${params.toString()}`), { headers: authHeaders() })
  if (res.status === 401 && token) { handleSessionExpired(); throw new Error('Session expired') }
  if (!res.ok) {
    const payload = await res.json().catch(() => null) as { error?: { code?: string; message?: string } } | null
    const code = payload?.error?.code
    // 'needs_reconnect'/'not_found' are recognized codes CalendarView branches
    // on to show a specific state; anything else falls through to a generic error.
    throw new Error(code === 'needs_reconnect' || code === 'not_found' ? code : (payload?.error?.message || 'Failed to load calendar events'))
  }
  const data = await res.json() as { events: CalendarEvent[] }
  return data.events
}
